<template>
  <div>
    <div class="overall-content">
      <div class="left">
        <div class="results-table">
          <div class="header-row">
            <div class="left">
            </div>
            <div class="right">
              <span>Overall</span>
            </div>
          </div>
          <div class="additive-constant-row">
            <div class="left">
              <span>Additive Constant</span>
            </div>
            <div class="right">
              <span>{{formatNumbers(results.additiveConstant)}}</span>
            </div>
          </div>
          <div v-for="(question, i) in resultQuestions" class="question-section" :key="i">
            <div class="question-row">
              <span>{{question.question}}</span>
            </div>
            <div>
              <div v-for="(answer, j) in question.answers" :key="j">
                <div class="answer-row">
                  <div class="left">
                    <span>{{answer.answer}}</span>
                  </div>
                  <div class="right">
                    <span>{{formatNumbers(answer.score)}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!question.isLast" class="border-placeholder">
              <div class="left">
              </div>
              <div class="right">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  import {
    LOADING_STARTED,
    LOADING_COMPLETED_SUCCESS,
    R_NAME_HOME,
    CSS_CLASS_NAME_SELECTED_TAB,
  } from '../../services/constants'

  export default {
    name: 'ResultsOverall',
    data() {
      return {}
    },
    computed: {
      ...mapGetters([]),
      studyResultsState() {
        return this.$store.state.studyResultsModule.studyResultsState
      },
      results() {
        return this.studyResultsState.data
      },
      resultQuestions() {
        if (this.results) {
          return this.results.questions.map((question, i, questions) => {
            question.isLast = i === questions.length - 1
            return question
          })
        }
        return []
      },
      wordsState() {
        return this.$store.state.studyResultsModule.studyResultsOverallWordsState.data
      },
    },
    methods: {
      formatNumbers(num){
        return Math.round(num)
      },
    },
    created() {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../../scss/main";

  .overall-content {
    padding: 1%;
    display: flex;
    font-size: 14px;
    color: $cyan-1;

    > .left {
      width: 100%;

      .results-table {

        .header-row {
          display: flex;
          padding: 10px 0;

          > .left {
            width: 80%;
          }

          > .right {
            width: 20%;
            text-align: right;
          }

          border-bottom: solid 1px $gray-2;
        }

        .additive-constant-row {
          display: flex;

          > .left, > .right {
            padding: 10px 0;
          }

          > .left {
            width: 80%;
            border-bottom: solid 1px $gray-2;
          }

          > .right {
            width: 20%;
            border-bottom: solid 1px $gray-2;
            text-align: right;
          }

        }

        .question-section {
          padding: 10px 0;

          .question-row {
            padding: 0 0 3px 0;
          }

          .answer-row {
            padding: 0 0 3px 0;
            display: flex;

            > .left {
              width: 80%;
            }

            > .right {
              width: 20%;
              text-align: right;
            }
          }

          .border-placeholder {
            > .left {
              width: 100%;
              border-bottom: solid 1px $gray-2;
            }

          }
        }
      }
    }

    > .right {
      width: 29%;

      > div {
        padding: 10px 0 10px 14px;

        .words {
          border-bottom: solid 1px $gray-2;
          margin: 0 0 15px 0;

          .cloud {
            min-height: 150px;
          }
        }
      }
    }
  }
</style>
